import { IconInfoSquare } from '@tabler/icons-react';
import { capitalize } from '@helpers/dotNotation';
import { Button } from '@components/ui/Button';
import { useTranslation } from 'react-i18next';

interface EquipmentDisplayProps {
  value: string;
  type: 'CHASSIS' | 'WEAPON' | 'ITEM';
  amount?: number;
  className?: string;
  noBlur?: boolean;
  children: React.ReactNode;
  onClick?: () => void;
}

export function EquipmentDisplay({ value, type, amount, ...props }: EquipmentDisplayProps) {
  const { t } = useTranslation();

  const imagePath = {
    CHASSIS: 'chassis',
    WEAPON: 'weapons',
    ITEM: 'items'
  }[type];

  const name = type === 'ITEM'
    ? t(`Items.${value}`)
    : capitalize(value);

  const imgPath = type === 'ITEM'
    ? `/assets/items/${value}.avif`
    : `/img/${imagePath}/${value}.avif`;

  const title = `${amount && amount > 1 ? `${amount}x ` : ''}${name}`;

  return (
    <div className={`${props.className} ${type.toLowerCase()} equipment-display-container`}>
      <Button className="equipment-display-img-container" onClick={props.onClick}>
        <div className="absolute inset-0 grid-overlay" />

        {props.onClick && (
          <div className="info-container">
            <IconInfoSquare className="text-secondary" size={16} />
          </div>
        )}

        <img
          className={props.noBlur ? '' : 'blur-animation'}
          src={imgPath}
          alt={name}
        />
      </Button>

      <div className="equipment-display-overview">
        <p className="equipment-title">{title}</p>
        {props.children}
      </div>
    </div>
  );
}